import defaultTo from 'lodash/fp/defaultTo';
import flow from 'lodash/fp/flow';
import has from 'lodash/fp/has';
import head from 'lodash/fp/head';
import split from 'lodash/fp/split';

const BRAZIL_TENANT_PREFIX = 'rio-brazil';
const KOREA_TENANT_PREFIX = 'rio-southkorea';
const EUROPE_TENANT_PREFIX = 'rio-eu';

export const DEFAULT_LOCALE = 'en-GB';
export const DEFAULT_LANG = 'en';
const SUPPORTED_LOCALES_DEFAULT = ['en-GB'];
const SUPPORTED_LOCALES_EUROPE = [
    'nb-NO',
    'cs-CZ',
    'da-DK',
    'de-DE',
    'et-EE',
    'en-GB',
    'es-ES',
    'fr-FR',
    'hr-HR',
    'it-IT',
    'lv-LV',
    'lt-LT',
    'hu-HU',
    'nl-NL',
    'pl-PL',
    'pt-PT',
    'ro-RO',
    'sk-SK',
    'sl-SI',
    'fi-FI',
    'sv-SE',
    'el-GR',
    'bg-BG',
];
const SUPPORTED_LOCALES_BRAZIL = ['en-GB', 'es-ES', 'pt-BR'];
const SUPPORTED_LOCALES_SOUTHKOREA = ['en-GB', 'ko-KR'];
export const supportedLocaleMap: { [key: string]: string } = {
    de: 'de-DE',
    'de-DE': 'de-DE',
    en: 'en-GB',
    'en-GB': 'en-GB',
    bg: 'bg-BG',
    'bg-BG': 'bg-BG',
    cs: 'cs-CZ',
    'cs-CZ': 'cs-CZ',
    da: 'da-DK',
    'da-DK': 'da-DK',
    es: 'es-ES',
    'es-ES': 'es-ES',
    el: 'el-GR',
    'el-GR': 'el-GR',
    et: 'et-EE',
    'et-EE': 'et-EE',
    fi: 'fi-FI',
    'fi-FI': 'fi-FI',
    fr: 'fr-FR',
    'fr-FR': 'fr-FR',
    hr: 'hr-HR',
    'hr-HR': 'hr-HR',
    hu: 'hu-HU',
    'hu-HU': 'hu-HU',
    it: 'it-IT',
    'it-IT': 'it-IT',
    lt: 'lt-LT',
    'lt-LT': 'lt-LT',
    lv: 'lv-LV',
    'lv-LV': 'lv-LV',
    nb: 'nb-NO',
    'nb-NO': 'nb-NO',
    nl: 'nl-NL',
    'nl-NL': 'nl-NL',
    pl: 'pl-PL',
    'pl-PL': 'pl-PL',
    pt: 'pt-PT',
    'pt-PT': 'pt-PT',
    'pt-BR': 'pt-BR',
    ro: 'ro-RO',
    'ro-RO': 'ro-RO',
    sk: 'sk-SK',
    'sk-SK': 'sk-SK',
    sl: 'sl-SI',
    'sl-SI': 'sl-SI',
    sv: 'sv-SE',
    'sv-SE': 'sv-SE',
    ko: 'ko-KR',
    'ko-KR': 'ko-KR',
    // chinese is only supported in minimal user info dialog
    zh: 'zh-CN',
    'zh-CN': 'zh-CN',
};

export const extractLanguageForGlossar = (value: string | undefined | null): string => {
    const extractedLanguage = extractLanguage(value) as string | null;
    // Korean and chinese, afrikaans and zulu are not supported in the glossar
    return !extractedLanguage || ['ko', 'zh', 'af', 'zu'].includes(extractedLanguage)
        ? DEFAULT_LANG
        : extractedLanguage;
};

export const getSupportedLocaleForTenant = (tenant: string) => {
    if (tenant.startsWith(EUROPE_TENANT_PREFIX)) {
        return SUPPORTED_LOCALES_EUROPE;
    } else if (tenant.startsWith(BRAZIL_TENANT_PREFIX)) {
        return SUPPORTED_LOCALES_BRAZIL;
    } else if (tenant.startsWith(KOREA_TENANT_PREFIX)) {
        return SUPPORTED_LOCALES_SOUTHKOREA;
    } else {
        return SUPPORTED_LOCALES_DEFAULT;
    }
};
export const extractLanguage = flow(defaultTo(DEFAULT_LOCALE), split('-'), head);

export const getSupportedLocale = (preferredLocale: string) =>
    has(preferredLocale, supportedLocaleMap) ? supportedLocaleMap[preferredLocale] : DEFAULT_LOCALE;
